import { Label } from "@/shared/components/ui/label";
import { DateStringPicker } from "@/shared/components/date-picker";
import { InputErrorMessages } from "@/shared/components/errors/input-error-messages";
import { cn } from "@/shared/lib/utils";

interface DateInputProps {
  label: string;
  date: string | null;
  onDateChange: (date: string | null) => void;
  hint?: string;
  errors?: string[];
  disabled?: boolean;
  showWeekNumber?: boolean;
  className?: string;
}

/**
 * @deprecated Use one of the options in {@link ../field/date-picker-field.tsx}
 */
export function DateInput({
  label,
  date,
  onDateChange,
  hint,
  errors,
  disabled,
  showWeekNumber = false,
  className,
}: DateInputProps) {
  return (
    <div className={cn("grid content-start gap-1.5", className)}>
      <Label>{label}</Label>
      <DateStringPicker
        date={date}
        onDateChange={onDateChange}
        markError={errors !== undefined && errors.length > 0}
        disabled={disabled}
        showWeekNumber={showWeekNumber}
      />
      <span className="text-muted-foreground text-sm" hidden={!hint}>
        {hint}
      </span>
      <InputErrorMessages errors={errors ?? []} />
    </div>
  );
}
